import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthenticationProvider } from '../../new/providers/authentication-provider';
import { FreshVersionProvider } from '../../new/providers/fresh-version-provider';
import { ThemeProvider } from '@shadcn/ui/theme-provider';
import { Toaster } from '@shadcn/ui/components/ui/toaster';
import { BlockingLoader } from './blocking-loader';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from '../../new/providers/create-apollo-client';
import { OAuthRedirectHandler } from '../../new/providers/oauth-redirect-handler';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            refetchOnMount: false,
            refetchInterval: false,
            refetchIntervalInBackground: false,
        },
    },
});

const apolloClient = createApolloClient();

export const BaseProviders = ({ children }: { children: React.ReactNode }) => {
    console.log('base providers rendered');

    return (
        <ThemeProvider defaultTheme="light" storageKey="andsend-vite-ui-theme">
            <Toaster />
            <FreshVersionProvider>
                <QueryClientProvider client={queryClient}>
                    <GoogleOAuthProvider clientId={import.meta.env.VITE_OAUTH_GOOGLE_CLIENT_ID}>
                        <AuthenticationProvider>
                            <ApolloProvider client={apolloClient.client}>
                                <OAuthRedirectHandler>
                                    <BlockingLoader>{children}</BlockingLoader>
                                </OAuthRedirectHandler>
                            </ApolloProvider>
                        </AuthenticationProvider>
                    </GoogleOAuthProvider>
                </QueryClientProvider>
            </FreshVersionProvider>
        </ThemeProvider>
    );
};
